import { captureException } from '@sentry/react';

import { USER_PROGRESS_ENTITY, USER_PROGRESS_EVENT } from '~/const';
import convertToFormData from '~/utils/convertToFormData';

type UserProgressData = {
  subdomain?: string;
  callbackUrl?: string;
  sessionToken?: string;
  userGUID?: string;
  entityType: USER_PROGRESS_ENTITY;
  entityId: string;
  event: USER_PROGRESS_EVENT;
  learnerId: string;
};

const sendUserProgressRequest = (apiUrl, params: UserProgressData) => {
  const formData = convertToFormData({
    ...params,
    clientReferer: window?.location?.hostname,
  });

  try {
    navigator.sendBeacon(`${apiUrl}/api/occ/user-progress`, formData);
  } catch (e) {
    captureException(e);
  }
};

export default sendUserProgressRequest;
